import { Button, Form } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IToken } from 'store/ducks/globalTypes';

export const LoginFormItem = styled(Form.Item)<IToken>`
  margin-bottom: ${(props) => `${props.token.margin}px`};

  .ant-input,
  .ant-input-affix-wrapper {
    padding: 16px 14px;
    border-radius: ${(props) => `${props.token.borderRadiusSM}px`};
    background-color: #ffffff !important;
  }

  .ant-input:-webkit-autofill,
  .ant-input:-webkit-autofill:hover,
  .ant-input:-webkit-autofill:focus,
  .ant-input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #ffffff inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  .ant-input-prefix {
    font-size: 20px;
    color: #757474 !important;

    .anticon svg {
      fill: #757474 !important;
    }
  }

  .ant-input-suffix,
  .ant-input-suffix span {
    font-size: 20px;
    color: #000000 !important;
  }

  .ant-input-password-icon,
  .ant-input-suffix .anticon,
  .ant-input-suffix .anticon-eye,
  .ant-input-suffix .anticon-eye-invisible {
    color: #000000 !important;
    filter: none !important;
  }

  .ant-col {
    min-width: 100%;

    label {
      color: #ffffff;
      font-weight: 700;
    }
  }
`;

export const ItemsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .ant-row.ant-form-item-row {
    min-width: 100%;
  }

  .ant-form-item .ant-form-item-label {
    text-align: initial;
  }
`;

export const BottomSection = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  > button {
    align-self: center;
  }
`;

export const StyledButton = styled(Button)<IToken>`
  min-width: 150px;
  background: ${(props) => props.token.colorPrimary};
  border-color: ${(props) => props.token.colorPrimary};

  &:hover {
    background: ${(props) => props.token.colorPrimaryHover};
    border-color: ${(props) => props.token.colorPrimaryHover};
    color: ${(props) => props.token.colorWhite};
  }

  &:focus {
    background: ${(props) => props.token.colorPrimaryHover};
    border-color: ${(props) => props.token.colorPrimaryHover};
    color: ${(props) => props.token.colorWhite};
  }

  &:active {
    background: ${(props) => props.token.colorPrimaryActive};
    border-color: ${(props) => props.token.colorPrimaryActive};
    color: ${(props) => props.token.colorWhite};
  }
`;

export const StyledLink = styled(Link)`
  margin-bottom: 15px;
  color: #ff4d4f;
  display: flex;
  flex-direction: column;

  &:hover {
    color: #ff7875;
  }

  span {
    text-align: center;
  }
`;

export const StyledDisabledButton = styled(Button)`
  margin-bottom: 15px;
  min-width: 205px;
  border-radius: 15px;
`;

export const SchemaSelectWrapper = styled('div')`
  width: 100%;
  min-width: 100%;

  .ant-select {
    width: 100% !important;
    min-width: 100% !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    padding: 16px 32px 16px 14px;
    border-radius: 6px;
    min-height: 48px;
    width: 100% !important;
    min-width: 100% !important;
    max-width: none !important;
  }

  .ant-select-selection-placeholder {
    line-height: 16px;
  }

  .ant-select-arrow {
    right: 14px;
    top: 25px;
  }
`;
